(function(){
  const LENGTHS={
    city:{
      value:'2',
      title:'Stadt und kurze Wege',
      text:'2 m bieten im Stadtbereich und auf kurzen Wegen eine gute Kontrolle.'
    },
    everyday:{
      value:'2,40',
      title:'Alltag und Spaziergänge',
      text:'2,40 m bieten eine gute Balance aus Kontrolle und Bewegungsfreiheit.'
    },
    park:{
      value:'3',
      title:'Park und mehr Freiraum',
      text:'3 m geben deinem Hund mehr Bewegungsfreiheit bei Spaziergängen.'
    },
    training:{
      value:'5',
      title:'Training und Distanz',
      text:'5 m bieten einen größeren Bewegungsradius für Training und Übungen.'
    }
  };

  const WIDTHS={
    tiny:{none:8,sometimes:10,strong:12},
    small:{none:10,sometimes:12,strong:15},
    medium:{none:12,sometimes:15,strong:18},
    large:{none:15,sometimes:18,strong:20}
  };

  const DOG={
    tiny:'sehr kleinen und leichten Hund',
    small:'kleinen Hund',
    medium:'mittelgroßen Hund',
    large:'großen und kräftigen Hund'
  };

  const DOG_SHORT={
    tiny:'sehr kleiner Hund',
    small:'kleiner Hund',
    medium:'mittelgroßer Hund',
    large:'großer Hund'
  };

  const PULL={
    none:'mit geringem Zugverhalten',
    sometimes:'mit gelegentlichem Zugverhalten',
    strong:'mit starkem Zugverhalten'
  };

  const PULL_SHORT={
    none:'kaum Zug',
    sometimes:'gelegentlicher Zug',
    strong:'starker Zug'
  };

  function normalize(value){
    return String(value||'')
      .toLowerCase()
      .replace(/\u00a0/g,' ')
      .replace(/×/g,'x')
      .replace(/\./g,',')
      .replace(/\s+/g,'')
      .trim();
  }

  function matches(candidate,wanted){
    const a=normalize(candidate);
    const b=normalize(wanted);

    return a===b||a.startsWith(b);
  }

  function escapeHtml(value){
    return String(value).replace(/[&<>"]/g,c=>({
      '&':'&amp;',
      '<':'&lt;',
      '>':'&gt;',
      '"':'&quot;'
    }[c]));
  }

  function formatLength(value){
    const num=Number(value);

    if(Number.isInteger(num)){
      return String(num);
    }

    return String(num).replace('.',',');
  }

  function parseSize(value){
    const original=String(value||'').trim();

    /*
      Erkennt zum Beispiel:

      2,40 m x 15 mm
      2.40 m × 15 mm
      2 m x 10 mm
      15 mm / 2,40 m
    */

    const lengthMatch=original.match(
      /(\d+(?:[.,]\d+)?)\s*m(?!m)/i
    );

    const widthMatch=original.match(
      /(\d+)\s*mm/i
    );

    if(!lengthMatch||!widthMatch){
      return null;
    }

    return{
      raw:original,
      length:Number(
        lengthMatch[1].replace(',','.')
      ),
      width:Number(
        widthMatch[1]
      )
    };
  }

  function init(root){
    if(root.dataset.lbReady==='true'){
      return;
    }

    root.dataset.lbReady='true';

    const $=s=>root.querySelector(s);

    const $$=s=>Array.from(
      root.querySelectorAll(s)
    );

    const dialog=$('[data-lb-dialog]');
    const panel=$('.lb__panel');
    const open=$('[data-lb-open]');
    const openTitle=$('[data-lb-open-title]');
    const close=$('[data-lb-close]');
    const title=$('[data-lb-title]');
    const progress=$('[data-lb-progress]');
    const bar=$('[data-lb-progress-bar]');
    const body=$('[data-lb-body]');
    const back=$('[data-lb-back]');
    const next=$('[data-lb-next]');
    const apply=$('[data-lb-apply]');
    const results=$('[data-lb-results]');
    const status=$('[data-lb-status]');
    const steps=$$('[data-lb-step]');

    const answers={
      usage:null,
      dog:null,
      pulling:null
    };

    let step=1;
    let oldOverflow='';
    let recommendations=[];
    let selected=null;
    let completed=false;

    let guideOpenedTracked=false;
    let sizeSelectedTracked=false;


    /*
    ========================================
    GA4 TRACKING
    ========================================
    */

    function trackGa4(
      eventName,
      eventParams
    ){
      if(typeof window.gtag!=='function'){
        console.warn(
          '[Leinenberater] Google Analytics ist noch nicht verfügbar:',
          eventName
        );

        return false;
      }

      window.gtag(
        'event',
        eventName,
        Object.assign(
          {
            product_path:
              window.location.pathname
          },
          eventParams||{}
        )
      );

      return true;
    }


    /*
    ========================================
    GRUNDFUNKTIONEN
    ========================================
    */

    function answerKey(){
      return step===1
        ?'usage'
        :step===2
          ?'dog'
          :step===3
            ?'pulling'
            :null;
    }


    function setStatus(
      message,
      type
    ){
      status.textContent=
        message||'';

      status.className=
        'lb__status'+
        (type?' is-'+type:'');
    }


    function updateChoices(){
      $$('[data-lb-answer]')
        .forEach(btn=>{

          btn.setAttribute(
            'aria-pressed',

            answers[
              btn.dataset.lbAnswer
            ]===btn.dataset.value
              ?'true'
              :'false'
          );

        });
    }


    function recommendation(
      type,
      label,
      length,
      width,
      text,
      facts,
      actualShopifyValue
    ){
      return{
        type,
        label,
        length,
        width,
        text,

        facts:facts||[],

        /*
          Wichtig:

          Hier verwenden wir möglichst
          den echten Variantentext des
          jeweiligen Produktes.
        */

        shopifyValue:
          actualShopifyValue||
          `${length} m x ${width} mm`,

        displayValue:
          `${length} m × ${width} mm`
      };
    }


    function unavailable(el){
      return !!el&&(
        el.disabled||

        el.getAttribute(
          'aria-disabled'
        )==='true'||

        [
          'disabled',
          'is-disabled',
          'sold-out',
          'unavailable'
        ].some(
          c=>el.classList.contains(c)
        )
      );
    }


    /*
    ========================================
    PRODUKT / VARIANTEN AUSLESEN
    ========================================
    */

    function getProductScope(){
      return root.closest(
        'product-info,'+
        'product-form,'+
        '.product,'+
        '.product-section,'+
        '.shopify-section'
      )||document;
    }


    function collectAvailableSizes(){

      const scope=
        getProductScope();

      const found=[];


      function add(
        value,
        isDisabled
      ){

        const parsed=
          parseSize(value);

        if(
          !parsed||
          isDisabled
        ){
          return;
        }


        const exists=
          found.some(
            item=>
              item.length===
                parsed.length
              &&
              item.width===
                parsed.width
          );


        if(!exists){
          found.push(parsed);
        }
      }


      /*
        SELECT / DROPDOWN
      */

      scope
        .querySelectorAll('select')
        .forEach(select=>{

          if(
            root.contains(select)
          ){
            return;
          }


          Array.from(
            select.options
          ).forEach(option=>{

            add(
              option.textContent||
                option.value,

              option.disabled
            );

          });

        });


      /*
        RADIO BUTTONS
      */

      scope
        .querySelectorAll(
          'input[type="radio"]'
        )
        .forEach(input=>{

          if(
            root.contains(input)
          ){
            return;
          }


          let label=null;


          if(input.id){

            try{

              label=
                scope.querySelector(
                  `label[for="${CSS.escape(input.id)}"]`
                );

            }catch(e){

              label=null;

            }

          }


          label=
            label||
            input.closest('label');


          const text=
            input.value||
            (
              label
                ?label.textContent
                :''
            );


          add(
            text,

            unavailable(input)||
            unavailable(label)
          );

        });


      /*
        BUTTON / SWATCH VARIANTEN
      */

      scope
        .querySelectorAll(
          'button[data-option-value],'+
          'button[data-value],'+
          'button[value],'+
          '[role="radio"]'
        )
        .forEach(btn=>{

          if(
            root.contains(btn)
          ){
            return;
          }


          const text=
            btn.dataset.optionValue||
            btn.dataset.value||
            btn.getAttribute('value')||
            btn.textContent;


          add(
            text,
            unavailable(btn)
          );

        });


      return found;
    }


    /*
    ========================================
    BESTE VORHANDENE GRÖSSE FINDEN
    ========================================
    */

    function chooseBestSize(
      sizes,
      targetLength,
      targetWidth
    ){

      if(!sizes.length){
        return null;
      }


      /*
        Niemals automatisch eine
        dünnere Breite empfehlen,
        als unsere Beratungslogik
        vorsieht.
      */

      const safe=
        sizes.filter(
          size=>
            size.width>=
              targetWidth
        );


      if(!safe.length){
        return null;
      }


      /*
        Bewertung:

        Länge ist wichtig,
        danach Nähe zur Zielbreite.

        Beispiel:

        Ziel:
        2,40 m × 12 mm

        vorhanden:
        2,40 × 15
        3 × 12

        -> 2,40 × 15 wird bevorzugt.
      */

      return safe
        .slice()
        .sort((a,b)=>{

          const scoreA=
            Math.abs(
              a.length-targetLength
            )*10
            +
            Math.abs(
              a.width-targetWidth
            );


          const scoreB=
            Math.abs(
              b.length-targetLength
            )*10
            +
            Math.abs(
              b.width-targetWidth
            );


          return scoreA-scoreB;

        })[0];
    }


    /*
    ========================================
    EMPFEHLUNGEN ERSTELLEN
    ========================================
    */

    function getRecommendations(){

      const lengthInfo=
        LENGTHS[
          answers.usage
        ];


      const targetLength=
        Number(
          String(
            lengthInfo.value
          ).replace(',','.')
        );


      const targetWidth=
        WIDTHS[
          answers.dog
        ][
          answers.pulling
        ];


      const available=
        collectAvailableSizes();


      const best=
        chooseBestSize(
          available,
          targetLength,
          targetWidth
        );


      /*
        Keine ausreichend passende
        Variante vorhanden.
      */

      if(!best){
        return[];
      }


      const bestLength=
        formatLength(
          best.length
        );


      const exactLength=
        Math.abs(
          best.length-
          targetLength
        )<0.001;


      const exactWidth=
        best.width===
        targetWidth;


      let primaryText='';


      /*
        LÄNGE
      */

      if(exactLength){

        primaryText+=
          lengthInfo.text;

      }else{

        primaryText+=
          `Für ${lengthInfo.title.toLowerCase()} liegt unsere Orientierung bei ${lengthInfo.value} m. `+
          `Bei diesem Produkt ist ${bestLength} m die nächstpassende verfügbare Länge.`;

      }


      /*
        BREITE
      */

      if(exactWidth){

        primaryText+=
          ` Die Breite von ${best.width} mm ist unsere Orientierung für einen ${DOG[answers.dog]} ${PULL[answers.pulling]}.`;

      }else{

        primaryText+=
          ` Für einen ${DOG[answers.dog]} ${PULL[answers.pulling]} liegt unsere Orientierung bei mindestens ${targetWidth} mm. `+
          `Bei diesem Produkt ist ${best.width} mm die nächstpassende verfügbare Breite.`;

      }


      const list=[

        recommendation(
          'primary',
          'Unsere Empfehlung',
          bestLength,
          best.width,
          primaryText,

          [
            lengthInfo.title,
            DOG_SHORT[
              answers.dog
            ],
            PULL_SHORT[
              answers.pulling
            ]
          ],

          best.raw
        )

      ];


      /*
      ========================================
      ALTERNATIVE:
      ETWAS LÄNGER
      ========================================
      */

      const longer=
        available

          .filter(
            size=>

              size.length>
                best.length

              &&

              size.width>=
                targetWidth
          )

          .sort((a,b)=>{

            const scoreA=
              Math.abs(
                a.length-
                best.length
              )*10
              +
              Math.abs(
                a.width-
                best.width
              );


            const scoreB=
              Math.abs(
                b.length-
                best.length
              )*10
              +
              Math.abs(
                b.width-
                best.width
              );


            return scoreA-scoreB;

          })[0];


      if(longer){

        list.push(

          recommendation(
            'longer',
            'Etwas länger',

            formatLength(
              longer.length
            ),

            longer.width,

            'Etwas mehr Bewegungsfreiheit bei weiterhin passender Breite.',

            [],

            longer.raw
          )

        );

      }


      /*
      ========================================
      ALTERNATIVE:
      ETWAS KRÄFTIGER
      ========================================
      */

      const thicker=
        available

          .filter(
            size=>
              size.width>
              best.width
          )

          .sort((a,b)=>{

            const scoreA=
              Math.abs(
                a.length-
                best.length
              )*10
              +
              Math.abs(
                a.width-
                best.width
              );


            const scoreB=
              Math.abs(
                b.length-
                best.length
              )*10
              +
              Math.abs(
                b.width-
                best.width
              );


            return scoreA-scoreB;

          })[0];


      if(thicker){

        const duplicate=
          list.some(
            item=>

              Number(
                String(
                  item.length
                ).replace(',','.')
              )===
              thicker.length

              &&

              item.width===
              thicker.width
          );


        if(!duplicate){

          list.push(

            recommendation(
              'thicker',
              'Etwas kräftiger',

              formatLength(
                thicker.length
              ),

              thicker.width,

              'Eine kräftigere Ausführung aus den verfügbaren Varianten dieses Produkts.',

              [],

              thicker.raw
            )

          );

        }

      }


      return list;
    }


    /*
    ========================================
    ERGEBNISKARTEN
    ========================================
    */

    function card(
      r,
      index
    ){

      const facts=
        r.facts.length
          ?
          `<span class="lb__facts">${
            r.facts
              .map(
                f=>
                  `<span class="lb__fact">${escapeHtml(f)}</span>`
              )
              .join('')
          }</span>`
          :'';


      return `
        <button
          type="button"
          class="lb__card${r.type==='primary'?' lb__card--primary':''}"
          data-lb-result="${index}"
          aria-pressed="${index===0?'true':'false'}"
        >

          ${
            r.type==='primary'
              ?'<span class="lb__badge">✓ Beste Wahl</span>'
              :''
          }

          <span class="lb__card-head">

            <span>

              <span class="lb__card-label">
                ${escapeHtml(r.label)}
              </span>

              <strong class="lb__card-size">
                ${escapeHtml(r.displayValue)}
              </strong>

            </span>

            <span
              class="lb__radio"
              aria-hidden="true"
            ></span>

          </span>

          <span class="lb__card-text">
            ${escapeHtml(r.text)}
          </span>

          ${facts}

        </button>
      `;
    }


    function updateApply(){

      apply.textContent=
        selected
          ?`${selected.displayValue} übernehmen`
          :'Größe übernehmen';

    }


    function renderResults(){

      recommendations=
        getRecommendations();


      selected=
        recommendations[0]||
        null;


      /*
        Keine passende Variante
      */

      if(!selected){

        results.innerHTML=`
          <div class="lb__empty">

            <strong>
              Für diese Angaben ist bei diesem Produkt aktuell keine passende Größe verfügbar.
            </strong>

            <p>
              Bitte gehe einen Schritt zurück und passe deine Angaben an oder wähle eine andere Leine.
            </p>

          </div>
        `;


        updateApply();

        apply.disabled=true;

        return;
      }


      const alternatives=
        recommendations
          .slice(1)
          .map(
            (r,i)=>
              card(r,i+1)
          )
          .join('');


      results.innerHTML=

        card(
          recommendations[0],
          0
        )

        +

        (
          alternatives
            ?
            '<div class="lb__divider">Mögliche Alternativen</div>'+
            alternatives
            :''
        );


      updateApply();

      apply.disabled=false;
    }


    function chooseResult(index){

      selected=
        recommendations[index];


      if(!selected){
        return;
      }


      results
        .querySelectorAll(
          '[data-lb-result]'
        )
        .forEach(btn=>{

          btn.setAttribute(
            'aria-pressed',

            Number(
              btn.dataset.lbResult
            )===index
              ?'true'
              :'false'
          );

        });


      setStatus('');

      updateApply();

      apply.disabled=false;
    }


    /*
    ========================================
    SCHRITTE DARSTELLEN
    ========================================
    */

    function render(){

      steps.forEach(el=>{

        el.hidden=
          Number(
            el.dataset.lbStep
          )!==step;

      });


      updateChoices();

      setStatus('');


      if(step<=3){

        progress.textContent=
          `Schritt ${step} von 3`;


        bar.style.width=
          `${step/3*100}%`;


        next.hidden=false;

        apply.hidden=true;

        back.hidden=
          step===1;


        next.disabled=
          !answers[
            answerKey()
          ];


        next.textContent=
          step===3
            ?'Empfehlung anzeigen'
            :'Weiter';

      }else{

        progress.textContent=
          'Deine Empfehlung';


        bar.style.width=
          '100%';


        renderResults();


        next.hidden=true;

        apply.hidden=false;

        back.hidden=false;
      }


      body.scrollTop=0;
    }


    /*
    ========================================
    DIALOG
    ========================================
    */

    function openDialog(){

      if(!guideOpenedTracked){

        guideOpenedTracked=
          trackGa4(
            'size_guide_opened'
          );

      }


      step=
        completed
        &&
        answers.usage
        &&
        answers.dog
        &&
        answers.pulling

          ?4
          :1;


      render();


      oldOverflow=
        document.documentElement
          .style.overflow;


      document.documentElement
        .style.overflow=
        'hidden';


      if(
        typeof dialog.showModal===
        'function'
      ){

        dialog.showModal();

      }else{

        dialog.setAttribute(
          'open',
          ''
        );

      }


      setTimeout(
        ()=>title.focus(),
        0
      );
    }


    function closeDialog(){

      if(
        typeof dialog.close===
        'function'
        &&
        dialog.open
      ){

        dialog.close();

      }else{

        dialog.removeAttribute(
          'open'
        );


        document.documentElement
          .style.overflow=
          oldOverflow;


        open.focus();
      }
    }


    /*
    ========================================
    SHOPIFY VARIANTE AUSWÄHLEN
    ========================================
    */

    function selectInside(
      scope,
      wanted
    ){

      let disabledFound=false;


      /*
        SELECT
      */

      for(
        const select
        of scope.querySelectorAll('select')
      ){

        if(
          root.contains(select)
        ){
          continue;
        }


        const options=
          Array.from(
            select.options
          )
          .filter(
            option=>

              matches(
                option.textContent,
                wanted
              )

              ||

              matches(
                option.value,
                wanted
              )
          );


        for(
          const option
          of options
        ){

          if(option.disabled){

            disabledFound=true;

            continue;
          }


          select.value=
            option.value;


          select.dispatchEvent(
            new Event(
              'input',
              {
                bubbles:true
              }
            )
          );


          select.dispatchEvent(
            new Event(
              'change',
              {
                bubbles:true
              }
            )
          );


          return'selected';
        }
      }


      /*
        RADIO INPUTS
      */

      for(
        const input
        of scope.querySelectorAll(
          'input[type="radio"]'
        )
      ){

        if(
          root.contains(input)
          ||
          !matches(
            input.value,
            wanted
          )
        ){
          continue;
        }


        if(
          unavailable(input)
        ){

          disabledFound=true;

          continue;
        }


        input.click();

        return'selected';
      }


      /*
        LABELS
      */

      for(
        const label
        of scope.querySelectorAll(
          'label'
        )
      ){

        if(
          root.contains(label)
          ||
          !matches(
            label.textContent,
            wanted
          )
        ){
          continue;
        }


        const input=

          (
            label.htmlFor
            &&
            document.getElementById(
              label.htmlFor
            )
          )

          ||

          label.querySelector(
            'input[type="radio"]'
          );


        if(
          unavailable(label)
          ||
          unavailable(input)
        ){

          disabledFound=true;

          continue;
        }


        (
          input||
          label
        ).click();


        return'selected';
      }


      /*
        BUTTONS / SWATCHES
      */

      for(
        const btn
        of scope.querySelectorAll(
          'button[data-option-value],'+
          'button[data-value],'+
          'button[value],'+
          '[role="radio"]'
        )
      ){

        if(
          root.contains(btn)
        ){
          continue;
        }


        const values=[

          btn.dataset.optionValue,

          btn.dataset.value,

          btn.getAttribute(
            'value'
          ),

          btn.textContent

        ].filter(Boolean);


        if(
          !values.some(
            v=>
              matches(
                v,
                wanted
              )
          )
        ){
          continue;
        }


        if(
          unavailable(btn)
        ){

          disabledFound=true;

          continue;
        }


        btn.click();

        return'selected';
      }


      return disabledFound
        ?'unavailable'
        :'not_found';
    }


    function selectSize(wanted){

      const scope=
        getProductScope();


      let result=
        selectInside(
          scope,
          wanted
        );


      if(
        result==='not_found'
        &&
        scope!==document
      ){

        result=
          selectInside(
            document,
            wanted
          );

      }


      return result;
    }


    /*
    ========================================
    EVENTS
    ========================================
    */

    $$('[data-lb-answer]')
      .forEach(btn=>{

        btn.addEventListener(
          'click',
          ()=>{

            answers[
              btn.dataset.lbAnswer
            ]=
              btn.dataset.value;


            updateChoices();

            next.disabled=false;
          }
        );

      });


    results.addEventListener(
      'click',
      e=>{

        const btn=
          e.target.closest(
            '[data-lb-result]'
          );


        if(btn){

          chooseResult(
            Number(
              btn.dataset.lbResult
            )
          );

        }

      }
    );


    open.addEventListener(
      'click',
      openDialog
    );


    close.addEventListener(
      'click',
      closeDialog
    );


    next.addEventListener(
      'click',
      ()=>{

        if(
          step<=3
          &&
          !answers[
            answerKey()
          ]
        ){
          return;
        }


        step=
          step>=3
            ?4
            :step+1;


        render();
      }
    );


    back.addEventListener(
      'click',
      ()=>{

        if(step>1){

          step--;

          render();

        }

      }
    );


    apply.addEventListener(
      'click',
      ()=>{

        const r=
          selected
          ||
          getRecommendations()[0];


        if(!r){
          return;
        }


        apply.disabled=true;

        apply.textContent=
          'Größe wird übernommen …';


        setStatus('');


        const result=
          selectSize(
            r.shopifyValue
          );


        if(
          result==='selected'
        ){

          completed=true;


          if(
            !sizeSelectedTracked
          ){

            sizeSelectedTracked=
              trackGa4(
                'size_guide_selected',
                {

                  selected_size:
                    r.displayValue,

                  recommendation_type:
                    r.type,

                  usage:
                    answers.usage,

                  dog_size:
                    answers.dog,

                  pulling:
                    answers.pulling

                }
              );

          }


          open.classList.add(
            'is-selected'
          );


          openTitle.textContent=
            `Ausgewählt: ${r.displayValue}`;


          setStatus(
            `${r.displayValue} wurde ausgewählt.`,
            'success'
          );


          apply.textContent=
            'Größe übernommen';


          setTimeout(
            ()=>{

              closeDialog();

              apply.disabled=false;

              updateApply();

            },
            700
          );

        }else{

          apply.disabled=false;

          updateApply();


          if(
            result==='unavailable'
          ){

            setStatus(
              `${r.displayValue} ist mit der aktuell gewählten Farbe oder dem Beschlag nicht verfügbar. Bitte wähle eine Alternative oder ändere eine andere Option.`,
              'error'
            );

          }else{

            setStatus(
              `Die Größe ${r.displayValue} wurde im Variantenwähler nicht gefunden. Prüfe bitte die Schreibweise der Größenoption.`,
              'error'
            );

          }


          status.focus();
        }

      }
    );


    dialog.addEventListener(
      'close',
      ()=>{

        document.documentElement
          .style.overflow=
          oldOverflow;


        open.focus();

      }
    );


    dialog.addEventListener(
      'click',
      e=>{

        if(
          e.target!==dialog
        ){
          return;
        }


        const r=
          panel.getBoundingClientRect();


        const inside=

          e.clientX>=r.left
          &&
          e.clientX<=r.right
          &&
          e.clientY>=r.top
          &&
          e.clientY<=r.bottom;


        if(!inside){

          closeDialog();

        }

      }
    );


    render();
  }


  /*
  ========================================
  INITIALISIERUNG
  ========================================
  */

  function initAll(scope){

    (
      scope||document
    )
      .querySelectorAll(
        '[data-lb-guide]'
      )
      .forEach(init);

  }


  if(
    document.readyState===
    'loading'
  ){

    document.addEventListener(
      'DOMContentLoaded',
      ()=>initAll()
    );

  }else{

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    e=>initAll(e.target)
  );

})();